import Vue from "vue";

export default {
	state: {
		offers: [],
		actualOffer: {}
	},
	mutations: {
		setOffersOnState(state, offers) {
			state.offers = offers;
		},
		setActualOfferOnState(state, actualOffer) {
			state.actualOffer = mapOfferFromBack(actualOffer);
		}
	},
	actions: {
		getOffersByClient({ commit }, idClient) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("offer/client/" + idClient)
					.then((response) => {
						commit("setOffersOnState", response.data.data);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getOffersBySupplier({ commit }, idSupplier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("offer/supplier/" + idSupplier)
					.then((response) => {
						commit("setOffersOnState", response.data.data);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getOffer({ commit }, idOffer) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("offer/" + idOffer)
					.then((response) => {
						commit("setActualOfferOnState", response.data.data);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateOfferStatus(_, { id, status }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("offer/" + id + "/status/" + status, {})
					.then((response) => {
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		}
	},
	getters: {
		offers({ offers }) {
			return offers;
		},
		actualOffer({ actualOffer }) {
			return actualOffer;
		}
	}
};

function mapOfferFromBack(offer) {
	let mappedOffer = {
		...offer,
		companyName: offer.companies.map(function ({ idCompany, companyName }) {
			return { name: `${idCompany} - ${companyName}`, value: idCompany };
		})
	};
	return mappedOffer;
}
